type Settings = {
  themeFileRootPath: string,
  productId?: number,
  customer: {
    id: number;
    email: string;
    name: string;
    ordersCount: number;
    totalSpent: string;
    rank: string
  } | null;
}
export const useSettings = (): Settings => {
  return Object.assign({}, ...Array.from(document.querySelectorAll('.settings')).map(el => {
    if(el.textContent){
      return JSON.parse(el.textContent)
    } else {
      return {}
    }
  }))
}